import { useCallback, useEffect, useRef, useState } from 'react'
import stylesDropdown from '../../components/_dropdown.module.sass'

const useDropdownDirection = () => {
  const [expandedPlacement, setExpandedPlacement] = useState('upwards')
  const containerRef = useRef<HTMLDivElement>()

  const actualizeOrientation = useCallback(() => {
    if (containerRef.current) {
      const position = containerRef.current.getBoundingClientRect()

      if (position.y > 300) {
        setExpandedPlacement('upwards')
      } else {
        setExpandedPlacement('downwards')
      }
    }
  }, [])

  useEffect(() => {
    window.addEventListener('scroll', actualizeOrientation)

    return () => {
      window.removeEventListener('scroll', actualizeOrientation)
    }
  }, [actualizeOrientation])

  return {
    containerRef: containerRef,
    dropdownStyle: stylesDropdown[expandedPlacement]
  }
}

export default useDropdownDirection
